import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AppComponent } from '../../app.component';
import { HubService } from '../../services/hub.service';
import { ECMSTableComponent } from './ecms-table.component';
import { EcmsEntry } from '../../types/ecms-entry';

@Component({
  selector: 'ecms-header',
  templateUrl: './ecms-header.component.html',
  styleUrls: ['./ecms-header.component.css'],
  providers: [HubService, ECMSTableComponent],
})

export class ECSMHeaderComponent implements OnInit {
  rowCount: string;
  constructor(
    private hubService: HubService,
  ) {
  }

  type: string;
  headerMPRNList: number[] = [];
  public uploadFlag: boolean = false;
  public removeFlag: boolean = false;
  public allFlag: boolean = false;
  public geoFlag: boolean = false;
  public rawFlag: boolean = false;
  public preFlag: boolean = false;
  public offlineFlag: boolean = false
  @ViewChild('child', { static: true }) child: ECMSTableComponent;
  searchParams = {} as EcmsEntry;

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.geoFlag = this.rawFlag = this.removeFlag = this.uploadFlag = this.offlineFlag =false;
    this.allFlag = true;
    this.type = "all";
  }

  exportCSV(){
    this.child.exportEcmsCSV();
  }

  receiveCount($event: string) {
    this.rowCount = $event
  }

  receiveMPRNList($event: any) {
    this.headerMPRNList = $event
  }

  receiveFlag($event: any) {
    this.uploadFlag = $event;
    this.removeFlag = $event;
    this.child.initalizeFromParent(this.searchParams, this.type);
  }

  displayUpload(): void {
    this.uploadFlag = !this.uploadFlag;
    this.removeFlag = false;
  }

  displayRemove(): void {
    this.removeFlag = !this.removeFlag;
    this.uploadFlag = false;
  }

  displayAll(): void {
    this.preFlag = this.geoFlag = this.rawFlag = this.removeFlag = this.uploadFlag = this.offlineFlag = false;
    this.allFlag = true;
    this.type = "all"
    this.child.initalize(this.searchParams, this.type);
  }

  displayPreApp(): void {
    this.allFlag = this.geoFlag = this.rawFlag = this.removeFlag = this.uploadFlag = this.offlineFlag = false;
    this.preFlag = true;
    this.type = "preapproved"
    this.child.initalize(this.searchParams, this.type);
  }

  displayNoGeo(): void {
    this.preFlag = this.allFlag = this.rawFlag = this.removeFlag = this.uploadFlag = this.offlineFlag = false;
    this.geoFlag = true;
    this.removeFlag = this.uploadFlag = false;
    this.type = "nogeopal"
    this.child.initalize(this.searchParams, this.type);
  }

  displayOffline(): void {
    this.preFlag = this.allFlag = this.rawFlag = this.removeFlag = this.uploadFlag = this.geoFlag = false;
    this.offlineFlag = true;
    this.removeFlag = this.uploadFlag = false;
    this.type = "offline"
    this.child.initalize(this.searchParams, this.type);
  }

  displayRaw(): void {
    this.preFlag = this.allFlag = this.geoFlag = this.removeFlag = this.uploadFlag = this.offlineFlag = false;
    this.rawFlag = true;
    this.type = "raw"
    this.child.initalize(this.searchParams, this.type);
  }

  getColor(toggle: boolean): any {
    if (toggle == true) {
      return '#c2185b';
    } else {
      return '#DDD';
    }
  }

}
